import React from 'react';

const Question = ({ question }) => {
  return <div className='question'>
    <h3 className='question__title'>{question.question}</h3>
    <div className='question__answer' dangerouslySetInnerHTML={{
      __html: question.answer
    }}></div>
  </div>;
}

export default Question;